import { useState, useEffect } from "react";
import { getCookie } from "../utils/cookieUtils";

function useAdminUserBatchInfo() {
  const [userName, setUserNames] = useState([]);
  const [batchesAssigned, setBatchedAssigned] = useState([]);
  const [studiesRemaining, setStudiesRemaining] = useState([]);
  const [batchesCompleted, setBatchesCompleted] = useState([]);
  const [completionDate, setCompletionDate] = useState([]);
  const [batchDetails, setBatchDetails] = useState([]);

  useEffect(() => {
      fetch(`${process.env.REACT_APP_API_URL}/percept_db/v1/user-batches-info`, {
      method: 'GET',
      headers: {
        'X-Spl-Username-Header': getCookie('X-Spl-Username-Header'),
      },
    })
      .then((response) => response.json())
      .then((data) => {
        if (data.data.length > 0){
        const userName = data.data.map((batch) => batch.suid);
        setUserNames(userName);
        console.log();
        const batchesAssigned = data.data.map(
          (batch) => batch.batches_assigned
        );
        setBatchedAssigned(batchesAssigned);
        const studiesRemaining = data.data.map((batch) => batch.studies_remaining);
        setStudiesRemaining(studiesRemaining);

        const batchesCompleted = data.data.map((batch) => batch.batches_completed);
        setBatchesCompleted(batchesCompleted);

        const completionDate = data.data.map((batch) => batch.completion_date);
        setCompletionDate(completionDate);
        const batchDetails = data.data.map((batch) =>
          batch.user_batch_details.map((detail) => {
            return {
              batchId: detail.batch_id,
              batchName: detail.batch_name,
              recentlyRatedFile: detail.recently_rated_file,
              lastAccessTime: detail.last_access_time,
              completionStatus: detail.completion_status,
            };
          })
        );
        setBatchDetails(batchDetails);
      } else {
        console.log("No data available");
      }}
      )
      .catch((error) => {
        setBatchDetails([]);
        console.log(error)
      });
  }, []);

  const userNameBatchDetails = userName.map((name, index) => ({
    user: name,
    batchDetails: batchDetails[index],
  }));

  return {
    userName,
    batchesAssigned,
    studiesRemaining,
    batchesCompleted,
    completionDate,
    userNameBatchDetails,
  };
}

export default useAdminUserBatchInfo;
